import React from "react";
import styles from "./ModalWrapper.module.css";
const FormWrapper = (props) => {
  const {
    children,
  } = props;

  return <div className={styles.ModalContainer}>{children}</div>;
};

export default FormWrapper;
